import { render, staticRenderFns } from "./TableTaxItemForm.vue?vue&type=template&id=066d8f58&"
import script from "./TableTaxItemForm.vue?vue&type=script&lang=js&"
export * from "./TableTaxItemForm.vue?vue&type=script&lang=js&"
import style0 from "./TableTaxItemForm.vue?vue&type=style&index=0&id=066d8f58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports